// suppress requests and errors on a just deleted project
const deletedProjectIdMapWithTTL: Map<string, boolean> = new Map()

export function registerProjectIdAsDeleted(projectId: string) {
	deletedProjectIdMapWithTTL.set(projectId, true)
	setTimeout(() => deletedProjectIdMapWithTTL.delete(projectId), 10000)
}

export function removeProjectIdAsDeleted(projectId: string) {
	deletedProjectIdMapWithTTL.delete(projectId)
}

export function projectIsDeleted(projectId: string) {
	return deletedProjectIdMapWithTTL.has(projectId)
}
